import {
  ApiPackRoutes,
  GetPackMembersRequest,
  GetPacksRequest,
  GroupUser,
  InvitePackMemberRequest,
  Pack,
  PackResource,
  ProfileGroupStatus,
  ResourceIDRequest
} from '@foxbun/lib-goferal-types';
import * as t from 'ts-codec';
import { ResourceId } from '@journeyapps-labs/micro-codecs';
import { BaseApiClient } from '../base/BaseApiClient';

export class PacksClient extends BaseApiClient {
  getPack(req: ResourceIDRequest) {
    return this.post({
      path: ApiPackRoutes.GET_PACK,
      req: ResourceId,
      res: PackResource,
      params: req,
      buffered: true
    });
  }

  getPacks(req: GetPacksRequest) {
    return this.paginate({
      path: ApiPackRoutes.GET_PACKS,
      req: GetPacksRequest,
      codec: PackResource,
      params: req
    });
  }

  getMyPackStatus(req: ResourceIDRequest) {
    return this.post({
      path: ApiPackRoutes.GET_MY_PACK_STATUS,
      req: ResourceId,
      res: ProfileGroupStatus.or(t.Null),
      params: req,
      buffered: true
    });
  }

  createPack(req: Pack) {
    return this.post({
      path: ApiPackRoutes.CREATE_PACK,
      req: Pack,
      params: req
    });
  }

  getPackMembers(req: GetPackMembersRequest) {
    return this.paginate({
      path: ApiPackRoutes.GET_PACK_MEMBERS,
      req: GetPackMembersRequest,
      codec: GroupUser,
      params: req
    });
  }

  invitePackMember(req: InvitePackMemberRequest) {
    return this.post({
      path: ApiPackRoutes.INVITE_PACK_MEMBER,
      req: InvitePackMemberRequest,
      res: ResourceId,
      params: req
    });
  }

  requestToJoinPack(req: ResourceIDRequest) {
    return this.post({
      path: ApiPackRoutes.REQUEST_TO_JOIN_PACK,
      req: ResourceId,
      res: ResourceId,
      params: req
    });
  }

  revokeRequestToJoin(req: ResourceIDRequest) {
    return this.post({
      path: ApiPackRoutes.REVOKE_REQUEST_TO_JOIN,
      req: ResourceId,
      params: req
    });
  }

  acceptRequestToJoinPack(req: t.Decoded<typeof ResourceId>) {
    return this.post({
      path: ApiPackRoutes.ACCEPT_REQUEST_TO_JOIN,
      req: ResourceId,
      params: req
    });
  }

  acceptPackInvite(req: t.Decoded<typeof ResourceId>) {
    return this.post({
      path: ApiPackRoutes.ACCEPT_PACK_INVITE,
      req: ResourceId,
      params: req
    });
  }

  leavePack(req: t.Decoded<typeof ResourceId>) {
    return this.post({
      path: ApiPackRoutes.LEAVE_PACK,
      req: ResourceId,
      params: req
    });
  }
}
